export default {
    backgroundColors: ['bg-red', 'bg-blue', 'bg-green', 'bg-purple'],
    player1: 0,
    player2: 1,
    timer: 90
}